import React from 'react'
import { withRouter } from 'react-router';
import { BusinessOutlined, DescriptionOutlined, LinkOutlined, MonetizationOnOutlined } from '@material-ui/icons';
import { checkPermission, getLocalStorageInfo } from '../../utils_v2';
import { jetStreamInstance, testLessor } from '../../../shared/components';
import CollapsibleSideNav from '../../elements/CollapsibleSideNav';

function ConfigSideNav({ location }) {
    const path = (location?.pathname || '').replace(/\/$/, '');
    const navItems = [
        { label: `${jetStreamInstance ? "Lessor/Holdco" : "Lessor"} Config`, to: '/configure', icon: BusinessOutlined, show: checkPermission('console', 'lessor_configuration', 'R'), active: path === '/configure' },
        { label: 'Introduction', to: '/configure/introduction', icon: DescriptionOutlined, show: checkPermission('console', 'introduction', 'R'), active: path.startsWith('/configure/introduction') },
        { label: 'Third Party Integration', to: '/configure/third-party-integration', icon: LinkOutlined, show: checkPermission('console', '3rd_party_integration', 'R'), active: path.startsWith('/configure/third-party-integration') },
        { label: 'Currencies', to: '/configure/currencies', icon: MonetizationOnOutlined, show: true, active: path.startsWith('/configure/currencies') },
    ];
    return (
        <CollapsibleSideNav storageKey='configSideNavCollapsed' navItems={navItems} showPageTitle />
    )
}
export default withRouter(ConfigSideNav)
